import config from "../../../configuration/config"
export function CarColorPicker({ color, colorName,active, imageBase64 = null, urlImageColor,name,...prop }) {
    let isActive = (color === active);
    if (imageBase64) {
        return (
            <div {...prop} className={"color-picker-car " + (isActive ? " active ":"")}>
                
                <div className={"color-picker-car-image "} style={{ BackgroundSize: 'cover', backgroundImage: `url("data:image/png;base64,${imageBase64}")` }}>
                </div>

                <div className={(isActive ? "active":"")}>
                    <img className={"lazyload"} hidden={!isActive} data-src={"/assets/icons/check.svg"} alt={"check"}  />
                </div>
            </div>
        );
    } else if (urlImageColor) {
        return (
            <div {...prop} className={"color-picker-car " + (isActive ? " active ":"")}>
                <div className={"color-picker-car-image "} style={{ BackgroundSize: 'cover',  backgroundImage: `url('${(config.FilePathURL + urlImageColor).replaceAll("\\","/")}')` }}>
                </div>

                <div className={(isActive ? "active":"")}>
                    <img className={"lazyload"} hidden={!isActive} data-src={"/assets/icons/check.svg"} alt={"check"}  />
                </div>
            </div>
        );
    }
    return (
        <div {...prop} className={"color-picker-car  text-center p-10" + (isActive ? " border-primary ":"")} style={{ background: color, BackgroundSize: 'cover' }}>
            <span className={"color-picker-car-text text-14 text-center m-5"} >{colorName}</span>
            {/* <div className={(isActive ? "active":"")}>
                <img className={"lazyload"} hidden={!isActive} data-src={"/assets/icons/check.svg"} alt={"check"} onError = {e => e.target.style.display = 'none'} />
            </div> */}
        </div>
    );
}
